/* 🤖 this file was generated by svg-to-ts */
export const matIconSignalCellular4Bar: {
  name: 'signal-cellular-4-bar';
  data: string;
} = {
  name: 'signal-cellular-4-bar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 22h20V2L2 22z"/></svg>`
};
